export const defaultState = {
  serverData: {
    Targets: {},
    Channels: {},
    VideoInputs: {},
    AudioInputs: {},
    Devices: {},
    Ingests: {},
    Outgests: {},
    Resources: {},
    Settings: {} as any,
    Scenes: {},
    Transcoders: {},
    Platforms: {} as any,
  },
  outcome: false,
  alredyStreamDevice: false,
  didLoadData: false,
};

export const CHANGE_CHANNEL_STATUS = 'CHANGE_CHANNEL_STATUS';
export const REQUIRE_OUTGEST = 'REQUIRE_OUTGEST';
export const CHANGE_AUDIO_DEVICE_STATUS = 'CHANGE_AUDIO_DEVICE_STATUS';
export const CHANGE_MUTE_STATUS_OF_DEVICE = 'CHANGE_MUTE_STATUS_OF_DEVICE';
export const CHANGE_MUTE_STATUS_OF_DESKTOP = 'CHANGE_MUTE_STATUS_OF_DESKTOP';
export const CHANGE_DESKTOP_VOLUME = 'CHANGE_DESKTOP_VOLUME';
export const CHANGE_MICROPHONE_VOLUME = 'CHANGE_MICROPHONE_VOLUME';
export const DISCONNECT_REQUESTED = 'DISCONNECT_REQUESTED';
export const CHANGE_CAMERA_STATUS = 'CHANGE_CAMERA_STATUS';
export const PREVIEW_SOURCES = 'PREVIEW_SOURCES';
export const PREVIEW_AUDIO_SOURCES = 'PREVIEW_AUDIO_SOURCES';
export const TOGGLE_STREAM_TO_CLOUD = 'TOGGLE_STREAM_TO_CLOUD';
export const CHANGE_ZOOM = 'CHANGE_ZOOM_SCALE';
export const ADD_NEW_CAMERA_LAYER = 'ADD_NEW_CAMERA_LAYER';
